import tw, { styled } from 'twin.macro';

import { motion } from '@sopranodesign/framer-motion';

import {
  flex,
  size,
  spacing,
  position,
  grid,
  border,
  colours,
  text,
  display
} from '../styles';

const Flex = styled(motion.div)`
  ${tw`flex`}

  ${flex}
  ${size}
  ${spacing}
  ${position}
  ${grid}
  ${border}
  ${colours}
  ${text}
  ${display}

  box-sizing: border-box;
`;

export default Flex;
